module.exports = __webpack_public_path__ + "img/sol.12552902.png";